import axiosInstance from './axios';

// Link Microsoft/Azure account
export const linkMicrosoftAccount = async () => {
    try {
        const response = await axiosInstance.post('accounts/settings/link-azure/', {});
        return response.data;
    } catch (error) {
        console.error('Error linking Microsoft account:', error);
        throw error;
    }
};

// Unlink Microsoft/Azure account
export const unlinkMicrosoftAccount = async newPassword => {
    try {
        const response = await axiosInstance.post('accounts/settings/unlink-azure/', {
            new_password: newPassword,
        });
        return response.data;
    } catch (error) {
        console.error('Error unlinking Microsoft account:', error);
        throw error;
    }
};

// Initiate Azure SSO Login
export const initiateAzureLogin = async (email = '') => {
    try {
        const url = email ? `accounts/auth/azure-login/?email=${encodeURIComponent(email)}` : 'accounts/auth/azure-login/';
        const response = await axiosInstance.get(url);
        return response.data;
    } catch (error) {
        console.error('Error initiating Azure login:', error);
        throw error;
    }
};

// Initiate Azure SSO Registration
export const initiateAzureRegistration = async invitationKey => {
    try {
        const response = await axiosInstance.get(`accounts/auth/azure-register/${invitationKey}/`);
        return response.data;
    } catch (error) {
        console.error('Error initiating Azure registration:', error);
        throw error;
    }
};

// Complete profile after SSO registration
export const completeProfile = async profileData => {
    try {
        const response = await axiosInstance.post('accounts/auth/complete-profile/', profileData);
        return response.data;
    } catch (error) {
        console.error('Error completing profile:', error);
        throw error;
    }
};

// Submit MFA Code for Azure SSO
export const submitAzureMFACode = async (ephemeralToken, code) => {
    try {
        const response = await axiosInstance.post('accounts/auth/login/code/', {
            ephemeral_token: ephemeralToken,
            code: code,
        });
        return response.data;
    } catch (error) {
        console.error('Error submitting MFA code:', error);
        throw error;
    }
};
